import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  "class": "wholesale-search pt-4 pb-5 position-relative"
};
var _hoisted_2 = {
  key: 0,
  "class": "container mb-5"
};
var _hoisted_3 = {
  "class": "opacity-60 mt-2 mb-5"
};
var _hoisted_4 = {
  key: 1,
  "class": "container mb-5 pb-5"
};
var _hoisted_5 = {
  "class": "opacity-60 mt-2 mb-5"
};
var _hoisted_6 = {
  "class": "card border-0 rounded-4-half mb-4 overflow-hidden"
};
var _hoisted_7 = {
  "class": "d-md-flex"
};
var _hoisted_8 = {
  "class": "flex-grow-1 ms-lg-4 mt-md-0 mt-4 me-lg-4 me-md-3 px-md-0 px-4"
};
var _hoisted_9 = {
  "class": "d-flex justify-content-between align-items-center mt-lg-4 mt-3"
};
var _hoisted_10 = {
  "class": "d-flex align-items-center gap-2"
};
var _hoisted_11 = {
  "class": "sh-text-dark-blue mb-0 font-size-md-16"
};
var _hoisted_12 = {
  "class": "details py-2 mb-3"
};
var _hoisted_13 = {
  "class": "badges mb-lg-4 mb-2 d-flex align-items-center line-height-19"
};
var _hoisted_14 = {
  key: 0,
  "class": "font-size-14 font-size-md-13 sh-color-gray-3 me-2 d-md-inline-flex align-items-center text-center"
};
var _hoisted_15 = {
  key: 1,
  "class": "font-size-14 font-size-md-13 sh-color-gray-3 me-2 d-md-inline-flex align-items-center text-center"
};
var _hoisted_16 = {
  "class": "font-size-14 font-size-md-13 sh-color-gray-3 me-2 d-md-inline-flex align-items-center text-center"
};
var _hoisted_17 = {
  "class": "opacity-80 font-size-14 font-size-md-13 line-height-19"
};
var _hoisted_18 = {
  "class": "d-flex align-items-md-center mb-lg-3 mb-md-2 mb-3"
};
var _hoisted_19 = {
  "class": "flex-grow-1 ms-2"
};
var _hoisted_20 = ["innerHTML"];
var _hoisted_21 = {
  "class": "d-flex align-items-md-center"
};
var _hoisted_22 = {
  "class": "flex-grow-1 ms-2"
};
var _hoisted_23 = ["innerHTML"];
var _hoisted_24 = {
  key: 2,
  "class": "position-absolute bottom-0 start-50 translate-middle-x cta-join w-100 text-center py-5"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_ctx.query && !_ctx.hasSearchResults ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h4", null, "We found " + _toDisplayString(_ctx.total) + " results for \"" + _toDisplayString(_ctx.query) + "\" in our directory", 1)])])) : _createCommentVNode("", true), _ctx.hasSearchResults ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("h4", null, "We found " + _toDisplayString(_ctx.total) + " results for \"" + _toDisplayString(_ctx.query) + "\" in our directory", 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, function (supplier) {
    return _openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[8] || (_cache[8] = _createElementVNode("div", {
      "class": "flex-shrink-0"
    }, [_createElementVNode("div", {
      "class": "position-relative card-img h-100"
    }, [_createElementVNode("img", {
      src: "/img/v5/ico-dir-lock-white-md.svg",
      "class": "position-absolute top-50 start-50 translate-middle ico-locked"
    }), _createElementVNode("img", {
      src: "/img/v5/img-demo-supplier.png",
      "class": "img-fluid image",
      width: "",
      height: ""
    })])], -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", {
      "class": _normalizeClass(['flag-icon-' + supplier.country_code_small, "flag-icon font-size-16"])
    }, " ", 2), _createElementVNode("h5", _hoisted_11, _toDisplayString(supplier.name), 1), _cache[0] || (_cache[0] = _createElementVNode("span", {
      "class": "bg-medium-green badge rounded-pill sh-text-product-green font-size-10 font-weight-semibold line-height-12 badge-verified"
    }, [_createElementVNode("img", {
      src: "/img/v5/ico-dir-shield.svg",
      "class": "ms-n1"
    }), _createElementVNode("span", {
      "class": "text"
    }, "Verified")], -1))]), _cache[1] || (_cache[1] = _createElementVNode("a", {
      href: "#Pricing",
      "class": "btn btn-outline-primary d-none d-md-block px-lg-4 btn-lg-join font-size-14 px-md-2 font-size-md-13"
    }, [_createElementVNode("img", {
      src: "/img/v5/ico-dir-lock.svg",
      "class": "mt-n1 me-2 d-none d-lg-inline-block"
    }), _createTextVNode(" Join to contact this supplier")], -1))]), _cache[7] || (_cache[7] = _createElementVNode("div", {
      "class": "d-grid mt-4 pb-2 d-md-none"
    }, [_createElementVNode("a", {
      href: "#Pricing",
      "class": "btn btn-outline-primary font-size-14"
    }, [_createElementVNode("img", {
      src: "/img/v5/ico-dir-lock.svg",
      "class": "mt-n1 me-2"
    }), _createTextVNode(" Join to contact this supplier")])], -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [supplier.ships_internationally ? (_openBlock(), _createElementBlock("span", _hoisted_14, _cache[2] || (_cache[2] = [_createElementVNode("img", {
      src: "/img/v5/ico-dir-globe.svg",
      "class": "d-block mx-auto"
    }, null, -1), _createTextVNode(" Ships worldwide")]))) : _createCommentVNode("", true), supplier.minimum_order_value === 'None' ? (_openBlock(), _createElementBlock("span", _hoisted_15, _cache[3] || (_cache[3] = [_createElementVNode("img", {
      src: "/img/v5/ico-dir-cart.svg",
      "class": "d-block mx-auto"
    }, null, -1), _createTextVNode(" No minimum order")]))) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_16, [_cache[4] || (_cache[4] = _createElementVNode("img", {
      src: "/img/v5/ico-dir-calendar.svg",
      "class": "d-block mx-auto"
    }, null, -1)), _createTextVNode(" " + _toDisplayString(supplier.years_in_salehoo_text) + " in SaleHoo", 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[5] || (_cache[5] = _createElementVNode("div", {
      "class": "flex-shrink-0"
    }, [_createElementVNode("img", {
      src: "/img/v5/ico-dir-tags.svg"
    })], -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
      innerHTML: supplier.brands,
      "class": "text-truncate-2"
    }, null, 8, _hoisted_20)])]), _createElementVNode("div", _hoisted_21, [_cache[6] || (_cache[6] = _createElementVNode("div", {
      "class": "flex-shrink-0"
    }, [_createElementVNode("img", {
      src: "/img/v5/ico-dir-products.svg"
    })], -1)), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
      innerHTML: supplier.products,
      "class": "text-truncate-2"
    }, null, 8, _hoisted_23)])])])])])])]);
  }), 256))])) : _createCommentVNode("", true), _ctx.hasSearchResults ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[9] || (_cache[9] = [_createElementVNode("div", {
    "class": "container pt-5 mt-5"
  }, [_createElementVNode("div", {
    "class": "my-5 pt-5"
  }, [_createElementVNode("a", {
    href: "#Pricing",
    "class": "btn btn-primary btn-md-y-padding px-4 btn-lg-join mt-3"
  }, [_createElementVNode("img", {
    src: "/img/v5/ico-dir-lock-white.svg",
    "class": "mt-n1 me-2"
  }), _createTextVNode(" Join to see all the suppliers")])])], -1)]))) : _createCommentVNode("", true)]);
}